import React, { Component } from 'react';
import classNames from 'classnames';
import { getLanguages, sessionStore, translate } from '../services';
import { CustomContent, IconButton, SvgImage } from '.';
import { PropTypes } from 'prop-types';
import { DownArrowIconNew, InfoIconNew, ProductMenuIconNew, arrowRightIcon, messageWarningIcon } from '../../style/images';
import { getResponsiveSize } from '../util/sizeHelper';
import { DataGrid } from '@mui/x-data-grid';
import { filter } from 'lodash';
import { Box, Button, IconButton as MuiIconButton, Tooltip } from '@mui/material';
import { LightTooltip } from '.';
import { DetailedModal } from './DetailedModal';
import { useSelector } from 'react-redux';
import { checkIsBomItemMain, getAccessories } from '../util';
import deepStrictEqual from 'deep-strict-equal';

const Tile = ( { children, className, detailTemplate, index, item, onExpand, style, view } ) => {
  const screenSize = useSelector(state=>state.screenSize)
  const onClick = e => detailTemplate && (screenSize.width>900|| view==="cart") && onExpand( item, index, e.target );
  // eslint-disable-next-line react/jsx-no-bind
  return <div className={ className } style={ style } onClick={ onClick }>
    { children }
  </div>;
};

const HeaderColumn = ( { className, column, index, style } ) => {
  return <div key={ index } className={ className + " " + (column.className || "")} style={style}>
    <span className={column.template==="ProductActions" && column.title==="Action"?"hide-header-label":''}>{ column.title && translate( column.title ) }</span>
    {column.template==="ProductCode"&&  <LightTooltip title={translate("click on the product code to access the data sheet")} arrow>
            <MuiIconButton className='product-id-tooltip' disableFocusRipple disableRipple disableTouchRipple>
              <Box sx={{width:"16px", height:"16px"}} component="img" src={InfoIconNew}></Box>
            </MuiIconButton>
          </LightTooltip>}
  </div>;
};

export class Grid extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      filterValue: null,
      selectedTile: -1,
      comment: ""
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.checkHeaderStyle();
  }

  componentDidUpdate() {
    this.checkHeaderStyle();
  }

  checkHeaderStyle = () => {
    const gridHeaderElement = document.getElementById("gridHeaderTiles");
    if(gridHeaderElement) {
      const gridDataElement = document.getElementById("gridDataTiles");
      gridHeaderElement.style.overflowY = this.props.isExpandable || (gridDataElement && 
          (gridDataElement.scrollHeight - gridDataElement.clientHeight) > 0) ? "auto" : "scroll";
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleCommentUpdate(text){
    this.setState({comment:text});
  }

  onToggle=(item)=>{
    this.props.showCartItemActions(item)
  }
  handleSearchValueChanged = e => {
    const { onFilterChanged, layout } = this.props;
    const { enableLocalFilter } = layout;
    if ( e.keyCode === 27 ) {
      // escape -> clear the inputbox
      this.searchInput.value = '';
    }

    e.preventDefault();
    setTimeout( function ( value ) {
      if ( !this.mounted ) {
        return;
      }
      if ( value === this.searchInput.value ) {
        // only change the value after sufficient time has elapsed
        // no need to search every input of the user
        this.setState( { filterValue: this.searchInput.value }, () => {
          !enableLocalFilter && onFilterChanged && onFilterChanged( this.state.filterValue );
        } );
      }
    }.bind( this, this.searchInput.value ), 300 );
  }

  selectTile = ( item, key, component ) => {
    const ignoreList = ['icon-button-icon', 'rect', 'g', 'path', 'input', 'icon-button', 'action-panel', 'product-code'];
    const { isExpandable } = this.props;
    const { selectedTile } = this.state;

    if ( isExpandable && isExpandable( item ) && ignoreList.none( item => component.tagName.toLowerCase() === item || component.classList.contains( item ) ) ) {
      this.setState( { selectedTile: selectedTile === key ? -1 : key } );
    }
  }

  getClassNames( layout, isTile = false ) {
    if ( !layout ) {
      return '';
    }

    const borders = layout.borders && layout.borders.split( /,| / ).map( border => border.toLowerCase() ) || [];

    const mobileDetailColumns = ["Image","Product_ID", "Description", "Price", "Actions", "LinkedIcon","Action", "Product Description", "Availability","materialNameLso","说明","PURCHASEPRICE","ShortDescriptionCN"  ]
    return classNames( {
      [layout.className]: layout.className,
      [`height-${ layout.height }`]: !isTile && layout.height,
      [`width-${ layout.width }`]: !isTile && layout.width,
      'grid-row': !isTile && layout.height,
      'grid-col': !isTile && layout.width,
      'h-center': !isTile && layout.horizontalAlignment === 1,
      'h-right': !isTile && layout.horizontalAlignment === 2,
      'v-center': !isTile && layout.verticalAlignment === 1,
      'v-bottom': !isTile && layout.verticalAlignment === 2,
      'l-border': borders.includes( 'left' ),
      'r-border': borders.includes( 'right' ),
      't-border': borders.includes( 'top' ),
      'b-border': borders.includes( 'bottom' ),
      'hide-on-medium': !isTile && layout.isHideable && !this.props.className==="mobile-grid-view", 
      'v-start':!isTile && layout.title==="Actions",
      'mobile-image-view': this.props.className==="mobile-grid-view" && layout.template==="LargeProductImage",
      [layout.title]: mobileDetailColumns.includes(layout.title),
      'hidden': !mobileDetailColumns.includes(layout.title) && layout.className!=="light-font" && layout.className!=="mobile-list"
    } );
  }

  getResponsiveSize( size ) {
    const sizes = size.toString().trim().split( ' ' );
    return sizes.reduce( ( result, currentSize ) => {
      const matches = currentSize.match( /^(\d+([.]\d*)?)(\S*)$/ );
      const unit = matches[3];
      const number = getResponsiveSize( Number( matches[1] ) );

      result += ` ${ number }${ unit }`;
      return result;
    }, '' );
  }

  getStyle(id, layout, isTile = false, isExpandedTile = false ) {
    let style = {};
    // using steps of 10% for width and height to simplify the layout
    let fixHeight = layout.fixHeight;
    let margin = layout.margin;
    if(id==="gridHeaderTiles"){
      fixHeight = "55";
      // margin = "24px 20px 24px 20px";
    }
    if ( isTile && layout.height ) {
      style.height = `${ layout.height * 10 }%`;
      style.minHeight = style.height;
    }

    if ( isTile && layout.width ) {
      style.width = `${ layout.width * 10 }%`;
    }

    if ( isTile && fixHeight ) {
      style.height = `${ fixHeight }px`;
      style.minHeight = style.height;
    }

    if ( isTile && layout.fixWidth ) {
      style.width = `${ this.getResponsiveSize( layout.fixWidth ) }px`;
    }

    if ( layout.margin ) {
      style.margin = this.getResponsiveSize( margin );

      if ( isExpandedTile ) {
        style.marginBottom = 0;
        style.marginTop = 0;
      }
    }

    if ( layout.padding ) {
      // style.padding = this.getResponsiveSize( layout.padding );
      style.padding = layout.padding;
    }
    return style;
  }

  setSearchInput = input => this.searchInput = input;

  renderToolbar() {
    return this.props.layout.enableToolbar && <div className="toolbar">
      <input
        ref={ this.setSearchInput }
        placeholder={ translate( 'Filter contents by' ) }
        onKeyUp={ this.handleSearchValueChanged }
        className="search-input"
      />
    </div>;
  }

  renderContent( layout, item, key ) {
    const NSTbom_ACC = this.props.NSTbom_ACC
    if(layout.title==="searchquantity"){
      layout.type = 1
    }
    const accessories=getAccessories(item)
    const accessorylength=accessories && accessories.length
    return <CustomContent key={ key } currentSelector={this.props.currentSelector} layout={ layout } currentView= { this.props.currentView } data={ item } view={this.props.view} title={item._accessory?.title} mobileSearchView={this.props.className==="mobile-grid-view"?true:false} NSTbom_ACC={NSTbom_ACC} handleCommentUpdate={this.handleCommentUpdate} accessorylength={accessorylength}/>;
  }

  renderColumn( layout, item, key ) {
    if ( !layout ) {
      return null;
    }

    let content = layout.rows
      ? layout.rows.map( ( row, key ) => this.renderRow( row, item, key ) )
      : this.renderContent( layout, item, key );

    return <div key={ key } className={ this.getClassNames( layout ) } style={this.props.className==="mobile-grid-view"?{}: this.getStyle( this.getClassNames( layout ), layout ) }>
      { content }
    </div>;
  }
  getAssignmentCount(product) {
    const classNames = 'accessory-count-badge';
    const { fromCart } = this.props;
    const siteSettings = sessionStore.get( 'siteSettings' );
    let additional_acc = []
    const mainaccessories = getAccessories(product, fromCart);
    if (product.looseadditionalProduct && product.looseadditionalProduct.length > 0) {
      additional_acc = getAccessories(product.looseadditionalProduct.firstOrDefault(), fromCart);
    }
    const acc_list = mainaccessories.concat(additional_acc)
    //if with new acc_list FG identified
    if (acc_list && acc_list.length > 0 && product.superCodeLSO && product.superCodeLSO != "待开" && product.superCodeLSO != "-") {
      // return classNames +' floating-NST';
      return <div className={classNames + ' floating-NST'} >
        <span>
          {acc_list.length * product.amount}
        </span>
      </div>
    }
    if (product.bomItems && product.bomItems.length) {
      //forward checking
      if (product.configurableProduct && product.superCodeLSO != "待开" && product.superCodeLSO != "-") {
        return product.bomItems.any(b => b.configuredAcc == false) ? <div className={classNames} >
          <span>
            {product.bomItems.length * product.amount}
          </span>
        </div> : <div className={classNames + ' floating-NST'} >
          <span>
            {product.bomItems.length * product.amount}
          </span>
        </div>;
      }
      else {
        return <div className={classNames} >
          <span>
            {product.bomItems.length * product.amount}
          </span>
        </div>;
      }
    }

    if (!product.configuration) {
      return null;
    }

    const lang = getLanguages().first();
    //This is to handle the wiringDiagramComponents to be excluded in the count of accessories
    let quantity = 0;
    let isBomItemMain = checkIsBomItemMain(product.configuration);
    if (product.configuration.bomComponents?.length > 0) {
      product.configuration.bomComponents.forEach(filter => {
        if (Number(filter.itemNumber) >= 9000 && !filter.component.includes('1SDA')) {
          // do nothing here, just skip the wiring diagram components from bom components count
        }
        else if (isBomItemMain) {
          // if(product.configuration.materialKey == siteSettings.properties.materialKey){
          if (siteSettings.properties?.modelConfigurators && siteSettings.properties?.modelConfigurators?.includes(product.configuration.materialKey)) {
            quantity = quantity + parseInt(filter.quantity * product.amount);
          }
          else {
            quantity = quantity + parseInt(filter.quantity);
          }
        }
        else {
          // quantity = quantity + parseInt(filter.quantity * product.amount);
          quantity = quantity + parseInt(product.amount);
        }
      });
    }
    quantity = quantity + (additional_acc?.length * product.amount);
    let NST_acc = []
    if (product.bom && product.bom.length > 0) {
      NST_acc = product.bom.map(b => b.name)
    }
    if (product.configuration?.bomComponents?.length) {
      if (!deepStrictEqual(acc_list, NST_acc)) {
        return <div className={classNames} >
          <span>
            {quantity}
          </span>
        </div>
      }
      return <div className={classNames + ' floating-NST'} >
        <span>
          {quantity}
        </span>
      </div>
    }
    /*if(item.superCodeLSO && item.superCodeLSO!="待开"&&item.superCodeLSO!="-"){
    return classNames +' floating-NST';
    }*/
    return <div className={classNames} >
    <span>
      {mainaccessories.length*product.amount}
    </span>
  </div>
    
  }
  renderRow( layout, item, key, isTopLayer = false ) {
    var flag=false;
    if ( !layout ) {
      return null;
    }
    const { isExpandable, cartActionsButton } = this.props;
    if(isExpandable){
       flag = isExpandable( item );
    }

    let content = layout.columns
      ? layout.columns.map( ( col, key ) => this.renderColumn( col, item, key ) )
      : this.renderContent( layout, item, key );

    if(this.props.className==="mobile-grid-view" && Array.isArray(content) && (this.props.view==="cart"||this.props.view==="accessory"||this.props.view==='cartaccessory')){
      content.splice(3,0, <span className='quantity'>{`${translate("Quantity")}: ${item.amount?item.amount:item.minOrderQuantity?item.minOrderQuantity:1}`}</span>)
    }


    let length = content.length;
    if(this.props.className==="mobile-grid-view" && Array.isArray(content) && this.props.view==="accessory"){
      length = content.length-1;
      // content.splice(length, 0, <div className="info-icon">
      //   <Box component="img" src={InfoIconNew} sx={{height:"16px", width:"16px"}}></Box>
      // </div>)
    }
    if(this.props.className==="mobile-grid-view" && Array.isArray(content) && this.props.view==="cart"){
      length = content.length-1;
      content.splice(length, 0, ...[<div className='Comment'>
      {`${translate("COMMENT")}`}:{item?.noteByUser?item?.noteByUser:""}
    </div>,<div className='item-action'>
      <IconButton className='white-round-button' icon={ProductMenuIconNew} onClick={()=>{this.onToggle(item)}}></IconButton>
    </div>])
    }
    if(this.props.className==="mobile-grid-view" && Array.isArray(content)){
      if(this.props.view==="cart"){
        length = length+1;
      }
      content[1] = <div className="mobile-product-detail">{
        content.slice(1, length).map(child=>child)
      }</div>
    }
    if(this.props.className==="mobile-grid-view" && Array.isArray(content) &&this.props.view==="accessory"){
      content.splice(2,0, content[length])
    }
    if(this.props.className==="mobile-grid-view" && Array.isArray(content) &&this.props.view==="cart"){
      content.splice(2,0, content[length])
    }
    return <div key={ key } className={ this.getClassNames( layout ) } style={this.props.className==="mobile-grid-view"?{}: this.getStyle(this.getClassNames( layout ), layout ) }>
      {
        flag && isTopLayer && isExpandable && key === 0 ? this.props.className==="mobile-grid-view" &&this.props.view==="cart"?
        <Box sx={{display:"flex", flexDirection:"column", gap:"2px"}}>
          {/*getAccessories( item ).length>0&&<div className={ this.getBadgeClassName( item ) } >
            <span>
              {getAccessories( item ).length}
            </span>
      </div>*/}
        {this.getAssignmentCount(item)}
          <div key={ `${ key }_expander` } className={classNames("expandable-indicator icon-button")}>
        <SvgImage source={ arrowRightIcon }/>
        </div></Box>
        :<div key={ `${ key }_expander` } className="expandable-indicator icon-button">
        { isExpandable( item ) && <SvgImage source={ DownArrowIconNew } toolTip={ translate( 'Show Configuration' ) } /> }
      </div>:<></>
        } 
        {
        !flag && isTopLayer && isExpandable && key === 0 && <div key={ `${ key }_expander` } className="non-expandable-indicator">
        { isExpandable( item ) && <SvgImage source={ DownArrowIconNew } toolTip={ translate( 'Show Configuration' ) } /> }
      </div>
      }
      {this.props.className==="mobile-grid-view" && Array.isArray(content)?this.props.view==="accessory"||this.props.view==="cart"?content.slice(0,3):content.slice(0,2): content }   
    </div>;
  }

  renderTile( item, key ) {
    const { detailTemplate, layout, template, useCustomLayout, isExpandable } = this.props;
    const { selectedTile } = this.state;
    const customLayout = useCustomLayout && useCustomLayout( item );
    const layoutToUse = customLayout ? this.props.getCustomLayout( customLayout ) : layout;
    const DetailComponent = detailTemplate;
    const TileComponent = template;
    const rowComponents = !TileComponent && layoutToUse.rows.map( ( row, key ) => this.renderRow( row, item, key, true ) );
    const className = classNames( 'tile', this.getClassNames( layoutToUse, true ) || '', this.props.className );
    const style = this.props.className==="mobile-grid-view"?{}:this.getStyle(className, layoutToUse, true, selectedTile === key );

    const tile = <Tile
      key={ key }
      className={ className }
      detailTemplate={ detailTemplate }
      index={ key }
      item={ item }
      style={ style }
      onExpand={ this.selectTile }
      view={this.props.view}
    >
      { TileComponent
        ? <TileComponent layout={ layoutToUse } item={ item } />
        : rowComponents }
    </Tile>;
    if ( selectedTile === key) {
      item.isExpanded = item.configuration ? true : false;
      return <div key={ `${ key }_expanded_tile` } className="expanded-tile" style={ { margin: layoutToUse.margin } }>
        { tile }
        <DetailComponent key={ `${ key }_detail` } parentLayoutType={ layoutToUse.view } { ...item } detailTemplate={ detailTemplate } isExpandable={isExpandable}/>
      </div>;
    }   
    item.isExpanded = item.configuration ? false : true;   
    return tile;
  }

  renderTiles() {
    const { filterValue } = this.state;
    const { items, predicate, layout, noItemsFound } = this.props;
    const { enableLocalFilter } = layout;
    const filteredItems = filterValue && predicate && enableLocalFilter
      ? items.filter( item => predicate( item, filterValue ) )
      : items;

    if(this.props.isLoading){
      return null
    }
    return !filteredItems || filteredItems.length === 0 ? noItemsFound ? React.cloneElement( noItemsFound ) : [] : filteredItems.map( ( item, key ) => this.renderTile( item, key ) );
  }



  renderHeader(){
    const { layout, useCustomLayout } = this.props;
    let { enableHeader, rows } = layout;
    let layoutToUse =  layout;
    if(this.props.items.length>0){
      const customLayout = useCustomLayout && useCustomLayout( this.props.items[0] );
      if(customLayout && customLayout==="switchgear"){
        layoutToUse = customLayout ? this.props.getCustomLayout( customLayout ) : layout;
        rows = layoutToUse.rows;
      }
    }
    const className = classNames( 'tile', this.getClassNames( layoutToUse ) || '' );
    
    if( !enableHeader ) {
      return null;
    }

    let headerColumns = rows && rows[0].columns.map( ( column, index ) =>{
      let style = {}
      
      if(column.template==="ProductActions"){
        return(<>
          <HeaderColumn key={ index+1 } column={ {...column, title:"Quantity"} } index={ index+1 } className={ `grid-header-row width-${2}` } style={{paddingRight:"0px", justifyContent:"center"}}/>
          <HeaderColumn key={ index } column={ column } index={ index } className={ `grid-header-row width-${2}` } style={{paddingLeft:"0px", justifyContent:"center"}}/>
        </>)
      }
      if(column.template==="SearchActions"){
        return(<>
          <HeaderColumn key={ index+1 } column={ {...column, title:"Quantity"} } index={ index+1 } className={ `grid-header-row width-${2}` } style={{paddingRight:"0px", justifyContent:"center"}}/>
          <HeaderColumn key={ index } column={ column } index={ index } className={ `grid-header-row width-${3}` } style={{paddingLeft:"0px", justifyContent:"center"}}/>
        </>)
      }
      if( column.template==="CartAllActions"){
        return(<>
          <HeaderColumn key={ index+1 } column={ {...column, title:"Quantity"} } index={ index+1 } className={ `grid-header-row width-${2}` } style={{paddingRight:"0px", justifyContent:"center"}}/>
          <HeaderColumn key={ index+2 } column={ {...column, title:"Quantity", title:"Comment"} } index={ index+2 } className={ `grid-header-row width-${2}` } style={{paddingRight:"0px", justifyContent:"center"}}/>
          <HeaderColumn key={ index } column={ column } index={ index } className={ `grid-header-row width-${4}` } style={{paddingLeft:"0px", justifyContent:"center"}}/>
        </>)
      }
      if(column.className==="apply-padding"){
        style={padding:"20px 24px"}
      }
      return <HeaderColumn key={ index } column={ column } index={ index } className={ `grid-header-row width-${column.width}` } style={style}/>
    }
      
    );
    if(layout.title!=="accessory" && layout.title+layout.view!=="searchproductsimple"){
      headerColumns = [<Box width="48px" minWidth="48px" className="expander-icon-space"></Box>, ...headerColumns]
    }
    const header = <div key={ 'header-columns' } className={ 'height-10 grid-row ' } style={ this.getStyle( 'height-10 grid-row ', layoutToUse ) }>
                    {headerColumns}
                    </div>;


    const tile = <Tile
      key={ "header-row" }
      className={ className }
      
      > 
    { header }
    </Tile>;
    layoutToUse.id = "gridHeaderTiles";
    return<>
        <div className="tiles" id="gridHeaderTiles" style= { this.getStyle("gridHeaderTiles", layoutToUse, true, true) }>{tile}</div> 
    </>


  }

  newRenderRow(layout, item, key, isTopLayer = false){
    var flag=false;
    if ( !layout ) {
      return null;
    }
    const { isExpandable } = this.props;
    if(isExpandable){
       flag = isExpandable( item );
    }
    const content = layout.columns
      ? layout.columns.filter(col=>col.property).map((col,key) => {
        let property = col.property;
        let column = {}
        column[property] = this.renderColumn(col, item, key) 
        return column
      })
      : this.renderContent( layout, item, key );
    return content
    // return <div key={ key } className={ this.getClassNames( layout ) } style={ this.getStyle( layout ) }>
    //   { content }
    //     {
    //       flag && isTopLayer && isExpandable && key === 0 && <div key={ `${ key }_expander` } className="expandable-indicator icon-button">
    //       { isExpandable( item ) && <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } /> }
    //     </div>
    //     } 
    //      {
    //       !flag && isTopLayer && isExpandable && key === 0 && <div key={ `${ key }_expander` } className="non-expandable-indicator">
    //       { isExpandable( item ) && <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } /> }
    //     </div>
    //     }   
    // </div>;
  }
  prepareItems(item, key){
    const { detailTemplate, layout, template, useCustomLayout } = this.props;
    const { selectedTile } = this.state;
    const customLayout = useCustomLayout && useCustomLayout( item );
    const layoutToUse = customLayout ? this.props.getCustomLayout( customLayout ) : layout;
    const DetailComponent = detailTemplate;
    const TileComponent = template;
    const rowComponents = !TileComponent && layoutToUse.rows.map( ( row, key ) => this.newRenderRow( row, item, key, true ) );

    const result = {}
    rowComponents[0].map((item, key)=>{result[Object.keys(item)]=item[Object.keys(item)]})
    result["id"] = key;
    return result
  }
  render() {
    return <div className="grid" onScroll={ this.props.onScroll }>
      { this.renderToolbar() }
      { this.renderHeader() }
      <div className="tiles" id="gridDataTiles">
      { this.renderTiles() }
      </div>
    </div>;
    // const { layout, predicate, items} = this.props;
    // const {rows, enableHeader} = layout;
    // let filteredItems = items.map((item, key)=>this.prepareItems(item, key));
    // let columns = rows[0].columns.filter(c=>c.property).map((column)=>{
    //     return{
    //       "field":column.property,
    //       "headerName":column.title && translate(column.title),
    //       "width":column.width*98,
    //       "renderCell": (params) => <CustomContent  key={ params.value.key } layout={ layout } data={ items[params.value.key] } />
    //     }
    // })
    // return(
    //   <div style={{ height: 400, width: '100%' }} onScroll={ this.props.onScroll }>
    //     <DataGrid
    //     columns={columns}
    //     rows={filteredItems}
    //     initialState={{
    //                   ...filteredItems.initialState,
    //                   pagination: { paginationModel: { pageSize: 10 } },}}>
    //     </DataGrid>
    //   </div>
    // )
  }
}

Grid.propTypes = {
  detailTemplate: PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.elementType] ),
  getCustomLayout: PropTypes.func.isRequired,
  isExpandable: PropTypes.func,
  items: PropTypes.arrayOf( PropTypes.oneOfType( [PropTypes.node, PropTypes.object] ) ),
  layout: PropTypes.shape( {
    enableToolbar: PropTypes.bool,
    enableLocalFilter: PropTypes.bool,
    rows: PropTypes.array,
    tileHeight: PropTypes.number,
    tileWidth: PropTypes.number
  } ),
  noItemsFound: PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.elementType] ),
  onScroll: PropTypes.func,
  predicate: PropTypes.func,
  template: PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.elementType] ),
  useCustomLayout: PropTypes.func,
  onFilterChanged: PropTypes.func
};